import { render, staticRenderFns } from "./stepper-wrapper.component.vue?vue&type=template&id=12740dba&"
import script from "./stepper-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./stepper-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports